"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wissensportalEnums = void 0;
var wissensportalEnums = exports.wissensportalEnums = {
  FINISHED: 'FINISHED',
  IN_PROGRESS: 'IN_PROGRESS',
  NOT_STARTED: 'NOT_STARTED'
};